import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';
import { ModalModule } from '@shared/components/modal/modal.module';
import { ConvertSizeModule } from '@shared/pipes/convert-size/convert-size.module';
import { CountryPipeModule } from '@shared/pipes/country/country-pipe.module';
import { SharedPipesModule } from '@shared/pipes/shared-pipes/shared-pipes.module';
import { ActionsMenuComponent } from './actions-menu/actions-menu.component';
// eslint-disable-next-line max-len
import { ApplicationUpdateRequiredComponent } from './application-update-required/application-update-required.component';
import { ModalImageViewerComponent } from './modal-image-viewer/modal-image-viewer.component';
import { NoDataMessageComponent } from './no-data-message/no-data-message.component';
import { ToggleFieldComponent } from './toggle-field/toggle-field.component';
import { FileCardComponent } from './file-card/file-card.component';
import { CdkOverlayComponent } from './cdk-overlay/cdk-overlay.component';
import { CompanyInfoComponent } from './company-info/company-info.component';

@NgModule({
  declarations: [ ActionsMenuComponent, ToggleFieldComponent, ModalImageViewerComponent, NoDataMessageComponent,
    ApplicationUpdateRequiredComponent,
    FileCardComponent,
    CdkOverlayComponent,
    CompanyInfoComponent ],
  exports: [ ActionsMenuComponent, ToggleFieldComponent, ModalImageViewerComponent, NoDataMessageComponent,
             ApplicationUpdateRequiredComponent, FileCardComponent, CdkOverlayComponent, CompanyInfoComponent ],
  imports: [
    CommonModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    MatInputModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    ModalModule,
    ConvertSizeModule,
    OverlayModule,
    RouterModule,
    SharedPipesModule,
    CountryPipeModule
  ],
})
export class TinyKitModule {
}
